import produce, { Draft, enableES5 } from 'immer';
import { ActionTypes } from '../models/actions';
import { HYDRATE_STORE_FROM_SESSION, SYSTEM_FINISHED_SUMMARIZATION } from '../models/actions/names';
import { DoneSummarization } from '../models/store';

enableES5();

const initState = {
  doneFirstSummarization: false,
};

export const statReducer = produce((draft: Draft<DoneSummarization>, action: ActionTypes) => {
  switch (action.type) {
    case SYSTEM_FINISHED_SUMMARIZATION:
      draft.doneFirstSummarization = true;
      break;

    case HYDRATE_STORE_FROM_SESSION: {
      try {
        if (action.payload.src === 'STATS') {
          return { ...draft, ...action.payload.store };
        }
        // eslint-disable-next-line no-empty
      } catch (e) {}
      break;
    }
  }
}, initState);
